import { useTranslation } from 'react-i18next'

const timings = [
  { key: 'timings.morning',    time: '6:00 AM',  duration: '45 min', prasad: 'Panchaamirtham' },
  { key: 'timings.abhishekam', time: '8:00 AM',  duration: '60 min', prasad: 'Vibhuti & Kumkum' },
  { key: 'timings.noon',       time: '12:00 PM', duration: '30 min', prasad: 'Sweet Pongal' },
  { key: 'timings.evening',    time: '6:00 PM',  duration: '45 min', prasad: 'Flowers' },
  { key: 'timings.night',      time: '8:00 PM',  duration: '30 min', prasad: 'Theertham' },
]

function isCurrentOrNext(timeStr) {
  const [timePart, meridiem] = timeStr.split(' ')
  const [h, m] = timePart.split(':').map(Number)
  let hours = h
  if (meridiem === 'PM' && hours !== 12) hours += 12
  if (meridiem === 'AM' && hours === 12) hours = 0
  const now = new Date()
  const target = new Date()
  target.setHours(hours, m, 0, 0)
  const diff = target - now
  return diff >= 0 && diff < 2 * 60 * 60 * 1000
}

export default function PoojaTimingsTable() {
  const { t } = useTranslation()

  return (
    <>
      {/* ── Mobile: card list (< md) ── */}
      <div className="md:hidden space-y-3">
        {timings.map((row) => {
          const active = isCurrentOrNext(row.time)
          return (
            <div
              key={row.key}
              className={`rounded-2xl border px-4 py-3 shadow-sm ${
                active
                  ? 'bg-orange-50 border-saffron/40'
                  : 'bg-white border-gold/20'
              }`}
            >
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-2">
                  {active && (
                    <span className="w-2 h-2 rounded-full bg-saffron animate-pulse shrink-0" />
                  )}
                  <span className="font-semibold text-charcoal text-sm">{t(row.key)}</span>
                </div>
                <span className={`font-bold text-sm ${active ? 'text-saffron' : 'text-charcoal'}`}>
                  {row.time}
                </span>
              </div>
              <div className="flex items-center justify-between pl-4 text-xs text-charcoal/50">
                <span>{row.duration}</span>
                <span className="font-medium text-gold-dark">{row.prasad}</span>
              </div>
            </div>
          )
        })}
      </div>

      {/* ── Desktop: full table (≥ md) ── */}
      <div className="hidden md:block overflow-x-auto rounded-2xl shadow-lg border border-gold/20">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-saffron text-white">
              <th className="px-5 py-3 text-left font-semibold">Pooja Name</th>
              <th className="px-5 py-3 text-left font-semibold">Time</th>
              <th className="px-5 py-3 text-left font-semibold">Duration</th>
              <th className="px-5 py-3 text-left font-semibold">Prasad</th>
            </tr>
          </thead>
          <tbody>
            {timings.map((row, i) => {
              const active = isCurrentOrNext(row.time)
              return (
                <tr
                  key={row.key}
                  className={`border-b border-gold/10 transition-colors ${
                    active ? 'bg-orange-50' : i % 2 === 0 ? 'bg-white' : 'bg-cream'
                  }`}
                >
                  <td className="px-5 py-3 font-medium text-charcoal">
                    <div className="flex items-center gap-2">
                      {active && (
                        <span className="inline-block w-2 h-2 bg-saffron rounded-full animate-pulse" />
                      )}
                      {t(row.key)}
                    </div>
                  </td>
                  <td className={`px-5 py-3 font-semibold ${active ? 'text-saffron' : 'text-charcoal'}`}>
                    {row.time}
                  </td>
                  <td className="px-5 py-3 text-charcoal/60">{row.duration}</td>
                  <td className="px-5 py-3 text-charcoal/60">{row.prasad}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}
